module.exports = __webpack_public_path__ + "static/img/poly.38b2770.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/poly.png
// module id = hhK+
// module chunks = 9